Dates = require 'lib/dates'
React = require 'react'
t = require('views/internal/recup-with-helpers')('canonical_card')
Util = require 'lib/util'

{
  ArchivedBadge
  AttachmentsBadge
  Avatar
  Board
  BoardAndListName
  Card
  CardBadges
  CardCover
  CardLabel
  CardLabels
  CardLink
  CardMembers
  CardTitle
  ChecklistBadge
  CommentsBadge
  DescriptionBadge
  DueDateBadge
  NotificationBadge
  PlaceholderCard
  SubscribedBadge
  ThemeProvider
  TrelloAttachmentsBadge
  VotesBadge
} = require '@atlassian/trello-canonical-components/canonical-card'

theme = {
  archivedIcon: require('images/canonical-card/archived-icon.svg')
  attachmentIcon: require('images/canonical-card/attachment-icon.svg')
  checklistIconComplete: require('images/canonical-card/checklist-icon-complete.svg')
  checklistIconIncomplete: require('images/canonical-card/checklist-icon-incomplete.svg')
  commentIcon: require('images/canonical-card/comment-icon.svg')
  descriptionIcon: require('images/canonical-card/description-icon.svg')
  dueDateIcon: require('images/canonical-card/duedate-icon.svg')
  dueDateIconComplete: require('images/canonical-card/duedate-complete-icon.svg')
  joinIcon: require('images/canonical-card/join-icon.svg')
  notificationIcon: require('images/canonical-card/notification-icon.svg')
  subscribeIcon: require('images/canonical-card/subscribe-icon.svg')
  trelloAttachmentIcon: require('images/canonical-card/trello-attachment-icon.svg')
  voteIcon: require('images/canonical-card/vote-icon.svg')
}

colors = {
  'business-blue': 'business-blue-500'
  'light-gray': 'light-gray-500'
  black: 'near-black'
  blue: 'trello-blue-500'
  green: 'green-500'
  lime: 'lime-500'
  orange: 'orange-500'
  pink: 'pink-500'
  purple: 'purple-500'
  red: 'red-500'
  sky: 'sky-500'
  yellow: 'yellow-500'
}

boardAndListNameTitle = (boardName, listName) ->
  result = "#{t.l('board')}: #{boardName}"
  if listName?
    result += ", #{t.l('list')}: #{listName}"
  result

boardHeaderColor = (bottomColor, brightness) ->
  if bottomColor
    bottomColor
  else if brightness == 'dark'
    '#333'
  else
    'light-gray-300'


class LoadingCanonicalCard extends React.Component
  displayName: 'LoadingCanonicalCard'

  render: t.renderable ->
    t.tag PlaceholderCard

class GenericErrorCanonicalCard extends React.Component
  displayName: 'GenericErrorCanonicalCard'

  render: t.renderable ->
    { errorText } = @props

    t.div '.canonical-card-error', =>
      t.tag ThemeProvider, { theme }, =>
        t.tag Board, { bgColor: 'light-gray-300' }, =>
          t.tag Card, { className: 'canonical-card-error-card' }, =>
            t.tag CardCover, {
              bgColor: 'light-gray-100'
              height: 40
              img: require('images/canonical-card/alert-taco.svg')
              className: 'error-card-cover'
              width: 38
            }
            t.tag CardTitle, =>
              t.format 'generic error', { message: errorText }

class UnauthorizedCanonicalCard extends React.Component
  displayName: 'UnauthorizedCanonicalCard'

  render: t.renderable ->
    t.div '.canonical-card-error', =>
      t.tag ThemeProvider, { theme }, =>
        t.tag Board, { bgColor: 'light-gray-300' }, =>
          t.tag Card, { className: 'canonical-card-error-card' }, =>
            t.tag CardCover, {
              bgColor: 'light-gray-100'
              height: 48
              img: require('images/canonical-card/bouncer-taco.svg')
              className: 'unauthorized-card-cover'
            }
            t.tag CardTitle, =>
              t.format 'unauthorized card error'

class ConfusedTacoCanonicalCard extends React.Component
  displayName: 'ConfusedTacoCanonicalCard'

  render: t.renderable ->
    t.div '.canonical-card-error', =>
      t.tag ThemeProvider, { theme }, =>
        t.tag Board, { bgColor: 'light-gray-300' }, =>
          t.tag Card, { className: 'canonical-card-error-card' }, =>
            t.tag CardCover, {
              bgColor: 'light-gray-100'
              height: 40
              img: require('images/canonical-card/confused-taco.svg')
              className: 'error-card-cover'
              width: 38
            }
            t.tag CardTitle, =>
              t.format @props.error

class NotFoundCanonicalCard extends React.Component
  displayName: 'NotFoundCanonicalCard'

  render: t.renderable ->
    t.tag ConfusedTacoCanonicalCard, { error: 'card not found error' }

class NetworkErrorCanonicalCard extends React.Component
  displayName: 'ServerErrorCanonicalCard'

  render: t.renderable ->
    t.tag ConfusedTacoCanonicalCard, { error: 'network error' }

class InvalidCanonicalCard extends React.Component
  displayName: 'InvalidCardCanonicalCard'

  render: t.renderable ->
    t.tag ConfusedTacoCanonicalCard, { error: 'invalid card error' }

class MinimalCanonicalCard extends React.Component
  displayName: 'MinimalCanonicalCard'

  constructor: (props) ->
    @props = props
    @state = @props

  render: t.renderable ->
    {
      cardName
      cardDue
      cardDueComplete
      cardUrl
      boardName
      boardBgColor
      boardBgBottomColor
      boardBgBrightness
      boardBgImage
      boardUrl
      listName
      isWide
    } = @state

    t.div =>
      t.div '.canonical-card', =>
        t.tag ThemeProvider, { theme }, =>
          t.tag Board, {
            bgColor: boardBgColor
            bgImage: boardBgImage
            headerBgColor: if boardBgBottomColor && boardBgBrightness then boardHeaderColor(boardBgBottomColor, boardBgBrightness)
            widthPx: if isWide then 360 else undefined
          }, =>
            t.tag CardLink, {
              href: cardUrl
            }, =>
              t.tag CardTitle, =>
                t.text cardName
              if cardDue
                t.tag CardBadges, =>
                  t.tag DueDateBadge, {
                    dueDate: new Date(cardDue),
                    isComplete: cardDueComplete
                  }, =>
                    t.text Dates.toDateString(cardDue)

            t.tag BoardAndListName, {
              boardName
              boardUrl
              listName
              title: boardAndListNameTitle(boardName, listName)
            }

class CanonicalCard extends React.Component
  displayName: 'CanonicalCard'

  render: t.renderable ->
    {
      board
      boardClassName
      card
      cardClassName
      labels
      list
      members
      numNotifications
    } = @props

    badges = card.get('badges')
    isArchived = card.get('closed')
    list = list || card.getList()

    t.div =>
      t.div '.canonical-card', =>
        t.tag ThemeProvider, { theme }, =>
          t.tag Board, {
            className: boardClassName
            bgColor: board.getPref('backgroundColor')
            bgImage: Util.smallestPreviewBiggerThan(board.getPref('backgroundImageScaled'), 250, 130)?.url ? board.getPref('backgroundImage')
            headerBgColor: boardHeaderColor(board.getPref('backgroundBottomColor'), board.getPref('backgroundBrightness'))
          }, =>
            t.tag CardLink, {
                href: card.get('url')
                className: cardClassName
              }, =>
              if labels?.length > 0
                t.tag CardLabels, =>
                  labels.forEach (label) =>
                    color = label.get('color')
                    if color == null then return

                    t.tag CardLabel, { color: colors[color] }, =>
                      t.text (label.get('name') || ' ')
              t.tag CardTitle, =>
                t.text card.get('name')
              t.tag CardBadges, =>
                if numNotifications > 0
                  t.tag NotificationBadge, { numUnread: numNotifications }
                if badges.subscribed
                  t.tag SubscribedBadge
                if badges.votes > 0
                  t.tag VotesBadge, { numVotes: badges.votes }
                if badges.due?
                  t.tag DueDateBadge, { dueDate: new Date(badges.due), isComplete: badges.dueComplete }, =>
                    t.text Dates.toDateString(badges.due)
                if badges.description
                  t.tag DescriptionBadge
                if badges.comments > 0
                  t.tag CommentsBadge, { numComments: badges.comments }

                trelloAttachments = if badges.attachmentsByType
                  badges.attachmentsByType.trello.board + badges.attachmentsByType.trello.card
                else
                  0

                attachments = badges.attachments - trelloAttachments
                if attachments > 0
                  t.tag AttachmentsBadge, { numAttachments: attachments }
                if trelloAttachments > 0
                  t.tag TrelloAttachmentsBadge, { numAttachments: trelloAttachments }
                if badges.checkItems > 0
                  t.tag ChecklistBadge, { numItems: badges.checkItems, numComplete: badges.checkItemsChecked }
                if isArchived
                  t.tag ArchivedBadge, =>
                    t.format 'archived card badge label'

              if members?.length > 0
                t.tag CardMembers, =>
                  for member in members by -1
                    avatarHash = member.get('avatarHash')
                    t.tag Avatar, {
                      deactivated: board.getOrganization()?.getMemberType(member) == 'deactivated'
                      img: avatarHash and [window.avatarDomain, avatarHash, '30.png'].join('/')
                      initials: member.get('initials')
                    }

            t.tag BoardAndListName, {
              boardName: board?.get('name')
              boardUrl: board?.get('url')
              listName: list?.get('name')
              title: boardAndListNameTitle(board?.get('name'), list?.get('name'))
            }

module.exports = {
  CanonicalCard
  GenericErrorCanonicalCard
  InvalidCanonicalCard
  LoadingCanonicalCard
  MinimalCanonicalCard
  NetworkErrorCanonicalCard
  NotFoundCanonicalCard
  UnauthorizedCanonicalCard
}



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-card/canonical-card-components.coffee